<template>
  <div class="personalization-container">
    <v-expansion-panel :expand="true" :value="panel">
      <v-expansion-panel-content
        v-for="(item, index) in order"
        :key="index"
        ref="expansionPanel"
        class="panel-header"
      >
        <template v-slot:header>
          <div>{{ $t('ownerData') }} {{ item.name }} #{{ index + 1 }}</div>
        </template>

        <v-card>
          <div class="description-container">
            <p style="margin-top: 2.5rem">{{ $t('requiredFieldsDescription') }}</p>
          </div>
          <div v-if="fields.length" class="form-container">
            <v-layout column>
              <v-flex v-for="(field) in fields" :key="field.key" class="pb-16">
                <component
                  :is="field.component"
                  v-model="buyer.personalization[index][field.key]"
                  :validator="vs && vs.buyer.personalization.$each[index][field.key]"
                  v-bind="field"
                  :error-messages="field.errorMessages"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sport-organization-ticket-personalization',
  props: {
    order: {
      type: Array,
      default: () => [],
    },
    schema: {
      type: Object,
      default: () => null,
    },
    vs: {
      type: Object,
      default: () => {},
    },
    buyer: {
      type: Object,
      default: () => {},
    },
    personalizationErrors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [],
      panel: [],
    }
  },
  validations() {
    return {
      buyer: {
        personalization: {
          $each: {
            ...this.schema.validationSchema,
          },
        },
      },
    }
  },
  watch: {
    personalizationErrors: {
      handler(validation) {
        if(validation.error) {
          this.order.forEach((item) => this.panel.push(1))
        } else {
          this.panel = []
        }
      },
      deep: true,
    },
  },
  methods: {
    initPersonalizationForm(){
      this.buyer.personalization = []
      const ordersLength = this.order.length
      for (let i = 0; i < ordersLength; i++) {
        const item = { paymentMethod: 'CreditCard' }
        this.fields.forEach(field => {
          item[field.key] = ''
        })
        this.buyer.personalization.push(item)
      }
    },
    fieldOrder(fields) {
      let attendeeFields = [...fields]
      attendeeFields.forEach(
        function (item, i) {
          if (item.isPrivate) {
            attendeeFields.splice(i, 1)
          }
          if (item.component === 'avatar-field') {
            attendeeFields.splice(i, 1)
            attendeeFields.unshift(item)
          }
        }.bind(this),
      )

      return attendeeFields.map(field => {
        return {
          ...field,
          label: field.label + (field.validations.required ? '*' : ''),
        }
      })
    },
  },
  mounted() {
    this.fields = this.fieldOrder(this.schema.attendeeFields)
    this.initPersonalizationForm()
  },
})
</script>
<style scoped>

.personalization-container {
  display: flex;
  flex-direction: column;
  padding: 32px 24px 40px 24px;
  gap: 2.5rem;
}

.panel-header{
  background-color: #E6F3FF !important;
}

.description-container {
  padding-top: 2px;
  margin-left: 10px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-left: 10px;
  margin-right: 10px;
  padding-top: 10px;
}
</style>
